import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';
import { IconType } from '../components/atoms/icon/icon';

export default {
  attributeName: 'appBlackoutsPostalCodes',
  isDragable: true,
  canOpen: true,
  canEdit: true,
  canCreate: false,
  canRemove: true,
  createPath: routes.POSTAL_GROUPS_NEW,
  editURL: routes.POSTAL_GROUPS_EDIT,
  emptyMessage: "There hasn't been a postalcode yet.",
  fields: [
    
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name to identify the rule',
      default: '',
      width: '10rem',
      canEdit: false,
      canCreate: false,
      canFilter: true,
      canOrder: true,
    },
    {
      attributeName: 'countryCode',
      label: 'Country',
      type: FormInputTypes.COUNTRY_FLAG,
      helpText: 'Country from the transaction was made',
      default: '',
      width: '10rem',
      canEdit: false,
      canCreate: false,
      canFilter: true,
      canOrder: true,
      exactWidth:'120px'
    },
  
    {
      attributeName: 'postalCodes',
      label: 'Postal Codes',
      type: FormInputTypes.TEXT_INPUT.TEXT_COMMA,
      helpText: 'Postal codes in this rule',
      default: '',
      canEdit: false,
      canCreate: false,
      canFilter: true,
      canOrder: true,
      exactWidth:'200px'
    },
  ],
};
